import { actionTypes } from '../actions/actionTypes/mboActionType';

let initialState = {
  goals: [],
  employees: [],
  userGoals: [],
  organizationLoader: false,
  employeeLoader: false,
  showSubmit: false,
  IsEditable: false,
  comments: [],
  MBOcomments: [],
  showCommentsLoader: false,
  reviews: [],
  updateOneonOneLoader: false,
  pyUILabel: 'Submit',
  sendBackComments: '',
  HRAssignedCases: [],
  PMReportees: [],
  HRFeedBack: [],
  HRBulkFeedBack: [],
  MBOStage: '',
  EmployeeObjectiveScore: '',
  completeHRAssessment: {},
  completeHRAssessmentLoader: false,
  completeHRAssessmentRowLoader: {},
  completeHRBulkAssessmentLoader: false,
  ShowHRAssessment: false,
  ShowPMAssessment: false,
  IsPMSubmited: false,
  OneOnOneSlots: [],
  getSlotsOneOnOneLoader: false,
  AllowNewOneOnOne: false,
  oneononeActionsLoader: false,
  IsEdit: false,
  saveMBOReviewLoader: false,
  openExcelFormatLoader: false,
  MBOStartDate: null,
  MBOEndDate: null,
  UpcomingObjectives: [],
  selectedCount: 0,
  TotalObjectives: 0,
  ObjectivesCompleted: 0,
  ObjectivesNotCompleted: 0,
  ObjectivesInProgress: 0,
  ObjectivesRejected: 0,
  ObjectivesRequestPending: 0,
  IsApprovalEnable: false,
  ObjCompletedList: [],
  ObjNotCompletedList: [],
  ObjInprogressList: [],
  ObjRejectedList: [],
  ObjRequestPendingList: [],
  pyUser: '',
  ManagerProceed: false,
  ManagerSubmitEnable: '',
  EmpProceed: false,
  EmployeeVisibiltyMsg: '',
  pxCreateOpName: '',
  IsSchedule: '',
  imgUrls: [],
  showLoaderForimages: false,
  alignloader: false,
  CycleList: [],
  cycleUrls: [],
  isBulkLoading: false,
  reviewLoader: false,
  ShowBulkToggleButton: false,
  OneOnOneAndCommentsLoader: false,
  HRReviewComments: '',
  HRReviewDraft: '',
  IsHRReviewSaved: true,
  HRReviewCommentLoader: false,
  SkipMYRMessage: '',
  loadingGoalId: null,
  IsPMEqualstoRM: false,
};

/**
 * Redux reducers.
 * Used to update state in the store after actions are issued.
 */
export function mbo(state = initialState, action) {
  // console.log(action);
  switch (action.type) {
    case actionTypes.SET_DATA:
      return {
        ...state,
        goals: action.data,
      };
    case actionTypes.SET_DATA_REVIEWS:
      return {
        ...state,
        reviews: action.data,
      };
    case actionTypes.GET_GOALS_SUCCESS:
      return {
        ...state,
        goals: action.goals.OrganizationGoals,
        HRFeedBack: action.goals.HRFeedBack,
        caseId: action?.goals?.pyID || '',
        MBOStartDate: action?.goals?.StartDate || null,
        MBOEndDate: action?.goals?.EndDate || null,
        MBOStage: action?.goals?.MBOStage || '',
        EmployeeObjectiveScore: action?.goals?.EmployeeObjectiveScore || '',
        organizationLoader: false,
        showSubmit: action?.goals?.showSubmit === 'true' ? true : false,
        IsEditable: action?.goals?.IsEditable === 'true' ? true : false,
        IsManager: action?.goals?.IsManager === 'true' ? true : false,
        IsPMSubmited: action?.goals?.IsPMSubmited === 'true' ? true : false || '',
        EmployeeVisibiltyMsg: action?.goals?.EmployeeVisibiltyMsg,
        IsApprovalEnable: action?.goals?.IsApprovalEnable,
        // MBOStage: action?.goals?.MBOStage,
        pyStatusWork: action.goals.pyStatusWork,
        reviews: action.goals?.Reviews || [],
        SkipMYRMessage: action.goals?.SkipMYRMessage || '',
        pyUILabel: action.goals.pyUILabel,
        sendBackComments: action.goals.sendBackComments,
        IsEdit: false,
        saveMBOReviewLoader: false,
        OneOnOneSlots: [],
        UpcomingObjectives: action?.goals?.UpcomingObjectivesSection,
        TotalObjectives: action?.goals?.TotalObjectives,
        ObjectivesCompleted: action?.goals?.ObjectivesCompleted,
        ObjectivesNotCompleted: action?.goals?.ObjectivesNotCompleted,
        ObjectivesInProgress: action?.goals?.ObjectivesInProgress,
        ObjectivesRejected: action?.goals?.ObjectivesRejected,
        ObjectivesRequestPending: action?.goals?.ObjectivesRequestPending,
        ObjCompletedList: action?.goals?.ObjCompletedList || [],
        ObjNotCompletedList: action?.goals?.ObjNotCompletedList || [],
        ObjInprogressList: action?.goals?.ObjInprogressList || [],
        ObjRejectedList: action?.goals?.ObjRejectedList || [],
        ObjRequestPendingList: action?.goals?.ObjRequestPendingList || [],
        ManagerProceed: action?.goals?.ManagerProceed || false,
        ManagerSubmitEnable: action?.goals?.ManagerSubmitEnable || '',
        EmpProceed: action?.goals?.EmpProceed === 'true' ? true : false,
        CycleList: action?.goals?.CycleList || [],
        isBulkLoading: false,
        reviewLoader: false,
        HRReviewComments: action?.goals?.HRReviewComments || '',
        IsPMEqualstoRM: action?.goals?.IsPMEqualstoRM === 'true' ? true : false || '',
      };

    case actionTypes.REVIEW_LOADER:
      return { ...state, reviewLoader: true };

    case actionTypes.GET_GOALS_FAILURE:
      return {
        ...state,
        goals: [],
        HRFeedBack: [],
        organizationLoader: false,
        showSubmit: action?.goals?.showSubmit === 'true' ? true : false,
        IsEditable: true,
        IsManager: false,
        reviews: [],
        sendBackComments: '',
        saveMBOReviewLoader: false,
        OneOnOneSlots: [],
        reviewLoader: false,
        IsPMEqualstoRM: false,
      };

    case actionTypes.GET_BULK_GOALS_SUCCESS:
      return {
        ...state,
        HRBulkFeedBack: action.goals.HRFeedBack,
        isBulkLoading: false,
        showSubmit: action?.goals?.showSubmit === 'true' ? true : false,
      };

    case actionTypes.GET_BULK_GOALS_FAILURE:
      return { ...state, HRFeedBack: [], isBulkLoading: false };

    case actionTypes.SHOW_BULK_LOADER:
      return { ...state, isBulkLoading: true };

    case actionTypes.POST_GOALS_SUCCESS:
      return {
        ...state,
        goals: action.goals.OrganizationGoals,
        caseId: action?.goals?.pyID || '',
        organizationLoader: false,
        showSubmit: action?.goals?.showSubmit === 'true' ? true : false,
        status: action?.goals?.pyStatusWork,
        IsEditable: action?.goals?.IsEditable === 'true' ? true : false,
        IsManager: action?.goals?.IsManager === 'true' ? true : false,
        IsPMSubmited: action?.goals?.IsPMSubmited === 'true' ? true : false || '',
        IsApprovalEnable: action?.goals?.IsApprovalEnable,
        MBOStage: action.goals.MBOStage,
        pyStatusWork: action.goals.pyStatusWork,
        reviews: action.goals?.Reviews || [],
        SkipMYRMessage: action.goals?.SkipMYRMessage || '',
        pyUILabel: action.goals.pyUILabel,
        sendBackComments: action?.goals?.sendBackComments,
        TotalObjectives: action?.goals?.TotalObjectives,
        ObjectivesCompleted: action?.goals?.ObjectivesCompleted,
        ObjectivesNotCompleted: action?.goals?.ObjectivesNotCompleted,
        ObjectivesInProgress: action?.goals?.ObjectivesInProgress,
        ObjectivesRejected: action?.goals?.ObjectivesRejected,
        ObjectivesRequestPending: action?.goals?.ObjectivesRequestPending,
        ObjCompletedList: action?.goals?.ObjCompletedList || [],
        ObjNotCompletedList: action?.goals?.ObjNotCompletedList || [],
        ObjInprogressList: action?.goals?.ObjInprogressList || [],
        ObjRejectedList: action?.goals?.ObjRejectedList || [],
        ObjRequestPendingList: action?.goals?.ObjRequestPendingList || [],
        alignloader: false,
        employees: action?.goals?.ReporteesMBOs || [],
        HRAssignedCases: action?.goals?.HRAssignedCases || [],
        PMReportees: action?.goals?.PMReporteesMBOs || [],
      };

    case actionTypes.POST_GOALS_FAILURE:
      return {
        ...state,
        caseId: action?.goals?.pyID || '',
        organizationLoader: false,
        showSubmit: action?.goals?.showSubmit === 'true' ? true : false,
        IsEditable: false,
        IsManager: false,
        reviews: [],
        sendBackComments: '',
        alignloader: false,
      };
    case actionTypes.POST_GOALS_LOADER:
      return {
        ...state,
        alignloader: true,
      };

    case actionTypes.GET_TEAM_GOALS_SUCCESS:
      return {
        ...state,
        employees: action?.data?.ReporteesMBOs || [],
        HRAssignedCases: action?.data?.HRAssignedCases || [],
        PMReportees: action?.data?.PMReporteesMBOs || [],
        userGoals: [],
        ShowHRAssessment: action?.data?.ShowHRAssessment === 'true' ? true : false || '',
        ShowPMAssessment: action?.data?.ShowPMAssessment === 'true' ? true : false || '',
        IsPMSubmited: action?.data?.IsPMSubmited === 'true' ? true : false || '',
        goals: [],
        organizationLoader: false,
        employeeLoader: false,
        ShowBulkToggleButton:
          action?.data?.ShowBulkToggleButton === 'true' ? true : false || '',
      };
    case actionTypes.GET_TEAM_GOALS_FAILURE:
      return {
        ...state,
        employees: [],
        userGoals: [],
        goals: [],
        organizationLoader: false,
        employeeLoader: false,
        status: action?.goals?.pyStatusWork,
        HRAssignedCases: [],
        PMReportees: [],
      };
    case actionTypes.SHOW_LOADER_FOR_ORG_LOADER:
      return {
        ...state,
        organizationLoader: true,
        goals: [],
      };

    case actionTypes.SHOW_LOADER_FOR_EMP_LOADER:
      return {
        ...state,
        employeeLoader: true,
        goals: [],
      };

    case actionTypes.GET_MBO_INTERACTIONS_SUCCESS:
      return {
        ...state,
        goals: action.intercations.OrganizationGoals,
        reviews: action.intercations?.Reviews || [],
        // caseId: action?.intercations?.pyID || ''
        comments: action.intercations?.InteractionComments,
        MBOcomments: action.intercations?.MainCommentList,
        pxCreateOpName: action.intercations?.pxCreateOpName,
        AllowNewOneOnOne: action.intercations.AllowNewOneOnOne === 'true' ? true : false,
        IsEdit: action.intercations.IsEdit === 'true' ? true : false,
        ManagerProceed: action.intercations?.ManagerProceed || false,
        showCommentsLoader: false,
        showAddCommentsLoader: false,
        goals: action.intercations.OrganizationGoals
          ? action.intercations.OrganizationGoals
          : state.goals,
        showSubmit: action?.intercations?.showSubmit
          ? action?.intercations?.showSubmit === 'true'
            ? true
            : false
          : state.showSubmit,
        IsEditable: action?.intercations?.IsEditable
          ? action?.intercations?.IsEditable === 'true'
            ? true
            : false
          : state.IsEditable,
        IsManager: action?.intercations?.IsManager
          ? action?.intercations?.IsManager === 'true'
            ? true
            : false
          : state.IsManager,
        MBOStage: action?.intercations?.MBOStage || state.MBOStage,
        pyStatusWork: action?.intercations?.pyStatusWork || state.pyStatusWork,
        reviews: action.intercations?.Reviews || state.reviews,
        updateOneonOneLoader: false,
        oneononeActionsLoader: false,
        pyUILabel: action?.goals?.pyUILabel || state.pyUILabel,
        pyUser: action?.intercations?.pyUser,
        IsSchedule: action?.intercations?.IsSchedule === 'true' ? true : false,
        EmpProceed: action?.intercations?.EmpProceed === 'true' ? true : false,
      };

    case actionTypes.GET_MBO_INTERACTIONS_FAILURE:
      return {
        ...state,
        comments: [],
        MBOcomments: [],
        showCommentsLoader: false,
        showAddCommentsLoader: false,
        updateOneonOneLoader: false,
        oneononeActionsLoader: false,
      };

    case actionTypes.GET_MBO_REQUEST_COMPLETION_SUCCESS:
      return {
        ...state,
        // caseId: action?.intercations?.pyID || '',
        UpcomingObjectives:
          action.updateProperty === true
            ? action.requestCompletion.UpcomingObjectivesSection
            : state.UpcomingObjectives,
        TotalObjectives: action?.requestCompletion?.TotalObjectives,
        ObjectivesCompleted: action?.requestCompletion?.ObjectivesCompleted,
        ObjectivesInProgress: action?.requestCompletion?.ObjectivesInProgress,
        ObjectivesRejected: action?.requestCompletion?.ObjectivesRejected,
        ObjectivesRequestPending: action?.requestCompletion?.ObjectivesRequestPending,
        ObjCompletedList: action?.requestCompletion?.ObjCompletedList || [],
        ObjNotCompletedList: action?.requestCompletion?.ObjNotCompletedList || [],
        ObjInprogressList: action?.requestCompletion?.ObjInprogressList || [],
        ObjRejectedList: action?.requestCompletion?.ObjRejectedList || [],
        ObjRequestPendingList: action?.requestCompletion?.ObjRequestPendingList || [],
        // comments: action.requestCompletion?.InteractionComments,
        // MBOcomments: action.requestCompletion?.MainCommentList,
        // pxCreateOpName: action.requestCompletion?.pxCreateOpName,
        // AllowNewOneOnOne: action.requestCompletion.AllowNewOneOnOne === 'true' ? true : false,
        // IsEdit: action.requestCompletion.IsEdit === 'true' ? true : false,
        ManagerProceed: action.requestCompletion?.ManagerProceed || false,
        showCommentsLoader: false,
        showAddCommentsLoader: false,
        goals: state.goals.map((orgGoal) => {
          const updatedOrgGoal = action.requestCompletion.OrganizationGoals?.find(
            (g) => g.ID === orgGoal.ID
          );

          if (!updatedOrgGoal) return orgGoal;

          return {
            ...orgGoal,
            EmpGoals: orgGoal.EmpGoals.map((empGoal) => {
              const updatedEmpGoal = updatedOrgGoal.EmpGoals?.find(
                (eg) => eg.EmployeeGoalID === empGoal.EmployeeGoalID
              );

              return updatedEmpGoal ? { ...empGoal, ...updatedEmpGoal } : empGoal;
            }),
          };
        }),
        // showSubmit: action?.requestCompletion?.showSubmit
        //   ? action?.requestCompletion?.showSubmit === 'true'
        //     ? true
        //     : false
        //   : state.showSubmit,
        // IsEditable: action?.requestCompletion?.IsEditable
        //   ? action?.requestCompletion?.IsEditable === 'true'
        //     ? true
        //     : false
        //   : state.IsEditable,
        // IsManager: action?.requestCompletion?.IsManager
        //   ? action?.requestCompletion?.IsManager === 'true'
        //     ? true
        //     : false
        //   : state.IsManager,
        MBOStage: action?.requestCompletion?.MBOStage || state.MBOStage,
        pyStatusWork: action?.requestCompletion?.pyStatusWork || state.pyStatusWork,
        // reviews: action.requestCompletion?.Reviews || state.reviews,
        updateOneonOneLoader: false,
        oneononeActionsLoader: false,
        // pyUILabel: action?.goals?.pyUILabel || state.pyUILabel,
        // pyUser: action?.requestCompletion?.pyUser,
        // IsSchedule: action?.requestCompletion?.IsSchedule === 'true' ? true : false,
        EmpProceed: action?.requestCompletion?.EmpProceed === 'true' ? true : false,
      };

    case actionTypes.GET_MBO_REQUEST_COMPLETION_FAILURE:
      return {
        ...state,
        comments: [],
        MBOcomments: [],
        showCommentsLoader: false,
        showAddCommentsLoader: false,
        updateOneonOneLoader: false,
        oneononeActionsLoader: false,
      };

    case actionTypes.ONEONONE_ACTIONS_LOADER:
      return {
        ...state,
        oneononeActionsLoader: true,
      };

    case actionTypes.SHOW_LOADER_FOR_COMMENTS:
      return {
        ...state,
        showCommentsLoader: true,
      };

    case actionTypes.LOADER_FOR_ADD_COMMENTS:
      return {
        ...state,
        showAddCommentsLoader: true,
      };

    case actionTypes.LOADER_FOR_UPDATE_ONEONONE:
      return {
        ...state,
        updateOneonOneLoader: true,
      };
    case actionTypes.CLEAR_DATA_MBO:
      return {
        ...state,
        HRFeedBack: [],
        goals: [],
      };
    case actionTypes.COMPLETE_HR_ASSESSSMENT_SUCCESS:
      return {
        ...state,
        HRAssignedCases: action?.data?.HRAssignedCases || [],
        HRBulkFeedBack: action.data?.HRFeedBack || [],
        completeHRAssessmentLoader: false,
        completeHRAssessmentRowLoader: {
          ...state.completeHRAssessmentRowLoader,
          [action.meta.pyID]: false,
        },
        completeHRAssessment: action?.data || {},
      };
    case actionTypes.COMPLETE_HR_ASSESSSMENT_FAILURE:
      return {
        ...state,
        HRAssignedCases: [],
        HRBulkFeedBack: [],
        completeHRAssessmentLoader: false,
        completeHRAssessment: {},
        completeHRAssessmentRowLoader: {
          ...state.completeHRAssessmentRowLoader,
          [action.meta.pyID]: false,
        },
      };
    case actionTypes.COMPLETE_HR_ASSESSSMENT_LOADER:
      return {
        ...state,
        completeHRAssessmentLoader: true,
      };
    case actionTypes.COMPLETE_HR_BULK_ASSESSSMENT_SUCCESS:
      return {
        ...state,
        HRBulkFeedBack: action?.data?.HRFeedBack || [],
        completeHRBulkAssessmentLoader: false,
      };
    case actionTypes.COMPLETE_HR_BULK_ASSESSSMENT_FAILURE:
      return {
        ...state,
        HRBulkFeedBack: [],
        completeHRBulkAssessmentLoader: false,
      };
    case actionTypes.COMPLETE_HR_BULK_ASSESSSMENT_LOADER:
      return {
        ...state,
        completeHRBulkAssessmentLoader: true,
      };
    case actionTypes.COMPLETE_HR_ASSESSSMENT_ROW_LOADER:
      return {
        ...state,
        completeHRAssessmentRowLoader: {
          ...state.completeHRAssessmentRowLoader,
          [action.payload.pyID]: action.payload.isLoading,
        },
      };
    case actionTypes.GET_SLOTS_ONEONONE_SUCCESS:
      return {
        ...state,
        OneOnOneSlots: action?.intercations?.data?.DisplaySlots || [],
        getSlotsOneOnOneLoader: false,
      };
    case actionTypes.GET_SLOTS_ONEONONE_FAILURE:
      return {
        ...state,
        OneOnOneSlots: [],
        getSlotsOneOnOneLoader: false,
      };
    case actionTypes.GET_SLOTS_ONEONONE_LOADER:
      return {
        ...state,
        getSlotsOneOnOneLoader: true,
      };

    case actionTypes.SAVE_MBO_REVIEWS_LOADER:
      return {
        ...state,
        saveMBOReviewLoader: true,
      };

    case actionTypes.OPEN_EMPTY_EXCEL_FORMATE_SUCCESS:
      return {
        ...state,
        openExcelFormatLoader: false,
      };
    case actionTypes.DELETE_ATTACHMEMNT_SUCCESS:
      return {
        ...state,
        deleteAttachmnetLoader: false,
        Attachmentslist: action?.data || [],
      };
    case actionTypes.DELETE_ATTACHMEMNT_FAILURE:
      return {
        ...state,
        deleteAttachmnetLoader: false,
      };
    case actionTypes.DELETE_ATTACHMEMNT_LOADER:
      return {
        ...state,
        deleteAttachmnetLoader: true,
      };
    case actionTypes.OPEN_EMPTY_EXCEL_FORMATE_FAILURE:
      return {
        ...state,
        openExcelFormatLoader: false,
      };
    case actionTypes.OPEN_EMPTY_EXCEL_FORMATE_LOADER:
      return {
        ...state,
        openExcelFormatLoader: true,
      };
    case 'VIEW_RECEIPT_SUCCESS':
      return {
        ...state,
        imgUrls: action?.cases || [],
        showLoaderForimages: false,
      };
    case 'VIEW_RECEIPT_FAILURE':
      return {
        ...state,
        imgUrls: [],
        showLoaderForimages: false,
      };

    case 'VIEW_RECEIPT_LODER':
      return {
        ...state,
        showLoaderForimages: true,
      };

    case 'PREVIEW_PERFORMANCE_DOC_SUCCESS':
      return {
        ...state,
        cycleUrls: action?.cases || [],
        showLoaderForimages: false,
      };

    case 'PREVIEW_PERFORMANCE_DOC_FAILURE':
      return {
        ...state,
        cycleUrls: [],
        showLoaderForimages: false,
      };

    case 'DOWNLOAD_MBO_PDF_SUCCESS':
      return {
        ...state,
        cycleUrls: action?.cases || [],
      };
    case 'DOWNLOAD_MBO_PDF_FAILURE':
      return {
        ...state,
        cycleUrls: [],
      };
    case actionTypes.NEW_ONEONONE_AND_COMMENTS_SUCCESS:
      return {
        ...state,
        OneOnOneAndCommentsLoader: false,
        loadingGoalId: null,
        goals: state.goals.map((orgGoal) => {
          const updatedOrgGoal = action.goals?.OrganizationGoals?.find(
            (g) => g.ID === orgGoal.ID
          );

          if (!updatedOrgGoal) return orgGoal;

          return {
            ...orgGoal,
            EmpGoals: orgGoal.EmpGoals.map((empGoal) => {
              const updatedEmpGoal = updatedOrgGoal.EmpGoals?.find(
                (eg) => String(eg.EmployeeGoalID) === String(empGoal.EmployeeGoalID)
              );

              // ✅ replace entire empGoal
              return updatedEmpGoal ?? empGoal;
            }),
          };
        }),
      };
    case actionTypes.NEW_ONEONONE_AND_COMMENTS_FAILURE:
      return {
        ...state,
        OneOnOneAndCommentsLoader: false,
      };
    case actionTypes.NEW_ONEONONE_AND_COMMENTS_LOADER:
      return {
        ...state,
        OneOnOneAndCommentsLoader: true,
        loadingGoalId: action.id,
      };
    case actionTypes.POST_HR_REVIEW_COMMENT:
      return {
        ...state,
        HRReviewComments: action.data.HRReviewComments,
        HRReviewCommentLoader: false,
      };
    case actionTypes.POST_HR_REVIEW_COMMENT_FAILURE:
      return {
        ...state,
        HRReviewCommentLoader: false,
      };
    case actionTypes.POST_HR_REVIEW_DRAFT:
      return {
        ...state,
        HRReviewDraft: action.data,
      };
    case actionTypes.IS_HR_REVIEW_SAVED:
      return {
        ...state,
        IsHRReviewSaved: action.data,
      };
    case actionTypes.HR_REVIEW_COMMENT_LOADER:
      return {
        ...state,
        HRReviewCommentLoader: true,
      };
    default:
      return state;
  }
}
